export const capitalize = (value: string): string => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const decapitalize = ([first, ...rest]: string): string => {
  return first.toLowerCase() + rest.join('');
};
